// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LPcD","colMin":"styles_colMin__2dCbE"};